import React from "react";
import { Link, useLocation } from "react-router-dom";
import { usePortalRole } from "../auth/PortalRoleContext";
import "./TopBar.css";

type Props = {
  title?: string;
  onSignOut?: () => void;
  email?: string;
};

export default function TopBar({ title = "Qumra", onSignOut, email }: Props) {
  const { pathname } = useLocation();
  const role = usePortalRole();
  const canUsePlatformBilling = role === "OWNER" || role === "INTEGRATOR";
  const tabClass = (path: string) =>
    `top-bar__tab${pathname === path ? " top-bar__tab--active" : ""}`;

  return (
    <header className="top-bar">
      <div className="top-bar__group">
        <div className="top-bar__title">{title}</div>
        <Link to="/dashboard" className={tabClass("/dashboard")}>Dashboard</Link>
        <Link to="/cameras" className={tabClass("/cameras")}>Cameras</Link>
        <Link to="/alerts" className={tabClass("/alerts")}>Alerts</Link>
        <Link to="/access-roles" className={tabClass("/access-roles")}>Access Roles</Link>
        <Link to="/users" className={tabClass("/users")}>Users</Link>
        <Link to="/billing" className={tabClass("/billing")}>Billing</Link>
        {canUsePlatformBilling && (
          <>
            <Link to="/invoices" className={tabClass("/invoices")}>Invoices</Link>
            <Link to="/payment-methods" className={tabClass("/payment-methods")}>Payments</Link>
          </>
        )}
      </div>
      <div className="top-bar__group">
        {email && <span className="top-bar__email">{email}</span>}
        {onSignOut && <button type="button" onClick={onSignOut} className="top-bar__logout">Logout</button>}
      </div>
    </header>
  );
}
